import {
  LoadingOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Card, Divider, Flex, Form, Row, Button, Upload } from "antd";
import { useEffect, useRef, useState } from "react";

import { useForm } from "antd/es/form/Form";
import { Footer } from "antd/lib/layout/layout";
import AddressInformationForEdit from "components/elements/AddressInformation/AddressInformationForEdit";
import CompanyInfoForEdit from "components/elements/CompanyInfo/CompanyInfoForEdit";
import ContactInfoForEdit from "components/elements/ContactInfo/ContactInfoForEdit";
import { RequiredMark } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useTranslation } from "react-i18next";
import { dataURLtoFile } from "utils/helper";
import * as service from "../services/companyApi";
import styles from "../styles/CompanyProfileEdit.module.css";
import FinancialInformationForEdit from "components/elements/FinancialInfo/FinancialInformationForEdit";
import SocialMediaInformationForEdit from "components/elements/SocialMediaInformation/SocialMediaInformationForEdit";
const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const beforeUpload = (file) => {
  return false;
};

const CompanyProfileEdit = ({
  isLoading = false,
  initialValues = {},
  companyTypeOptions = [],
  provinceOptionsTh = [],
  provinceOptionsEn = [],
  districtOptionsTh = [],
  districtOptionsEn = [],
  subDistrictOptionsTh = [],
  subDistrictOptionsEn = [],
  bankOptions = [],
  onCancel = () => { },
  onSubmit = () => { },
  handleProviceChange = () => { },
  handleDistrictChange = () => { },
  setPageType = () => { },
}) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const { t } = useTranslation();
  const formikRef = useRef(null);
  const [form] = useForm(null);

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("common.upload")}
      </div>
    </button>
  );

  useEffect(() => {
    if (initialValues.companyLogo) {
      setLoading(true);
      getBase64(initialValues.companyLogo, (url) => {
        setImageUrl(url);
      });
    }
  }, [initialValues.companyLogo]);
  // useEffect(() => formikRef?.current?.validateForm(), []);
  return (
    <FormAntd
      form={form}
      initialValues={{
        ...initialValues,
        bankAccount: initialValues?.bankInformation?.bankAccount?.id,
        bankAccountNo: initialValues?.bankInformation?.bankAccountNo,
        bankReferenceCode: initialValues?.bankInformation?.bankreferencecode,
        serviceCode: initialValues?.bankInformation?.servicecode
      }}
      onFinish={onSubmit}
      requiredMark={RequiredMark}
      colon={false}
    >
      <Form.Item shouldUpdate={(prev, curv) => false}>
        {({ getFieldValue, setFieldValue }) => {
          const onAvatarChange = async (info) => {
            setLoading(true);
            const compressImg = await service.compressedImage({
              file: info.file
            })
            getBase64(compressImg.data, (url) => {
              setLoading(false);
              setFieldValue("companyLogo", dataURLtoFile(url));
              setImageUrl(url);
            });
          };

          const onClearAvatar = (e) => {
            e.stopPropagation();
            setFieldValue("companyLogo", null);
            setLoading(false);
            setImageUrl(null);
          };

          const onProviceChange = (val) => {
            handleProviceChange(val.provinceCode);
            setFieldValue("districtId", null);
            setFieldValue("subdistrictId", null);
            setFieldValue("zipCode", null);
          };

          const onDistrictChange = (val) => {
            handleDistrictChange(val.districtCodeId);
            setFieldValue("subdistrictId", null);
            setFieldValue("zipCode", null);
          };

          const onSubDistrictChange = (val) => {
            setFieldValue("zipCode", subDistrictOptionsTh?.find?.(o => o.value == val)?.zipCode || null);
          };

          return (
            <Flex gap={25} vertical={true}>
              <Row justify="center" style={{ paddingTop: "1%" }}>
                <Form.Item name={"companyLogo"}>
                  <Upload
                    name="avatar"
                    listType="picture-circle"
                    className={styles.avatarUploader}
                    showUploadList={false}
                    beforeUpload={beforeUpload}
                    onChange={onAvatarChange}
                    action={null}
                  >
                    {imageUrl ? (
                      <>
                        <img
                          src={imageUrl}
                          alt="avatar"
                          className={styles.avatar}
                          style={{
                            width: "100%",
                          }} />
                        <MinusCircleOutlined
                          className={styles.avatarMinusIcon}
                          onClick={onClearAvatar} />
                      </>
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                </Form.Item>
              </Row>
              <Card>
                <CompanyInfoForEdit
                  header={
                    <b className={styles.infoTopic}>
                      {t("company_profile.label.general_information")}
                      <Divider />
                    </b>
                  }
                  companyTypeOptions={companyTypeOptions} getFieldValue={getFieldValue} />
              </Card>
              <Card>
                <AddressInformationForEdit
                  provinceOptionsTh={provinceOptionsTh}
                  provinceOptionsEn={provinceOptionsEn}
                  districtOptionsTh={districtOptionsTh}
                  districtOptionsEn={districtOptionsEn}
                  subDistrictOptionsTh={subDistrictOptionsTh}
                  subDistrictOptionsEn={subDistrictOptionsEn}
                  onProviceChange={
                    (val) => {
                      onProviceChange(provinceOptionsEn.find(o => o.value == val))
                    }
                  }
                  onDistrictChange={(val) => {
                    onDistrictChange(districtOptionsTh.find(o => o.value == val))
                  }}
                  onSubDistrictChange={onSubDistrictChange} />
              </Card>
              <Card>
                <ContactInfoForEdit />
              </Card>
              <Card>
                <FinancialInformationForEdit bankOptions={bankOptions} />
              </Card>
              <Card>
                <SocialMediaInformationForEdit />
              </Card>
              <Footer style={{
                zIndex: 999,
                bottom: 1,
                position: 'sticky',
                backgroundColor: "white",
                height: "fit-content",
                // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                padding: '10px 50px',
                // display: 'flex',
                // justifyContent: 'end',
                // alignItems: 'center',
              }}>
                <Row justify="end" style={{ gap: "12px" }}>
                  <Button type="default" onClick={() => {
                    onCancel();
                  }}
                    style={{ width: "80px", height: "40px", borderRadius: "8px", padding: "8px 16px" }}
                  >
                    {t("common.cancel").toUpperCase()}
                  </Button>
                  <Button type="primary" htmlType="submit" style={{ width: "80px", height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
                    {t("common.submit").toUpperCase()}
                  </Button>
                </Row>
              </Footer>
            </Flex>
          );
        }}
      </Form.Item>
    </FormAntd>
  );

};

export default CompanyProfileEdit;
